export class ServiceStatisticMiniEntity {
  date?: string
  numberOfOrders?: number
  numberOfCanceledOrders?: number
  numberOfDeliveredOrders?: number
  // numberOfFailedOrders?: number
  // numberOfUniqueOrderUsers?: number
  numberOfNotDeliveredOrders?: number
  numberOfDeliveryTimeOrders?: number
}
